export enum StateVariant {
  EMPTY = 'empty',
  ERROR = 'error',
}

export enum IllustrationVariant {
  HTTP_500 = '500',
  HTTP_404 = '404',
}
